import React, { memo } from "react";
import { Paper, PaperProps } from "@material-ui/core";
import useAppPaper from "./index.hooks";

type AppPaperProps = {} & PaperProps;

const AppPaper = ({ ...props }: AppPaperProps) => {
  const { classes } = useAppPaper();

  return <Paper classes={classes.paper} {...props} />;
};

export default memo(AppPaper);
